<script setup>
//import version_1 from '@/assets/images/version_1_sce_1.png';
</script>
<template>
   <BaseContainer>
    <BaseContentContainer>
    <h1 class="display-6 text-center">Human–Computer Interaction (HCI)</h1>
  <!-- Intro Section -->
    <div class="fs-5 mb-4 text-center">
    Investigating how learners interact with technology through user-centred design, 
    usability, accessibility, and interactive experiences that make Computer Science 
    concepts more intuitive and meaningful.
    </div><br><br>
   <!-- Render InfoButtons only on tab 2 -->
  <div class="">
    <h5 class="text-success">Applying HCI to Secondary Computer Science Education, reflecting on the
      current, on-going teaching practise. </h5>
    <p class="mb-3">
      
    </p>
    <div class="accordion" id="teachingAccordion">
    <div v-for="item in accordions" :key="item.id">

       
        <GenericAccordion :object="item">
  
           <div class="row">
           <div class="d-flex flex-column align-items-center">
           <GenericCard  
            v-for="card in getCards(item.id)"
            :key="card.id"
            :card="card"
         
              >
            <template #image>
            <img v-if="card.image" :src="card.image" style="max-width: 100%; height: auto;" class="" />
            </template>
           </GenericCard>
           </div>
      
          </div>
        
        </GenericAccordion>
        
    </div>
</div>
    
  </div>

   </BaseContentContainer>
</BaseContainer>    
</template>

<script>

import GenericAccordion  from '@/components/GenericAccordion.vue';
import GenericCard from '@/components/GenericCard.vue';
import accordionsData from '@/data/hci_accordions'
import cardsData from '@/data/hci_cards'
import BaseContainer  from '@/components/BaseContainer.vue';
import BaseContentContainer  from '@/components/BaseContentContainer.vue';
  //:title="card.title"
            //:subtitle="card.subtitle"
            //:text="card.description"
export default {
  name: 'HCI_View',

    components: {
      GenericAccordion , GenericCard, BaseContainer,BaseContentContainer,
  },

  data() {
    return {
    accordions: accordionsData,
    cards: cardsData,
      
    };
  },
  methods: {
  getCards(accordionId) {
    return this.cards.filter(c => c.accordionId === accordionId)
  }
}
};
</script>


<style scoped>
.my-container {
  width: 980px;
  /*background: lightgoldenrodyellow; 
  border: 2px solid black;*/
}

</style>
